import { authEndpoints } from "@/api/auth/auth.endpoints";
import { applySessionResponseToStore } from "@/utils/authHelpers";
import { consumeReturnPath, toNavigateTarget } from "@/utils/postLoginReturn";
import { Box, Loader, Text } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";
import axios from "axios";

export const Route = createFileRoute("/_unauthenticated/sso/callback")({
  validateSearch: (search: Record<string, unknown>) => ({
    code: (search.code as string | undefined) ?? "",
    state: (search.state as string | undefined) ?? "",
  }),
  loader: async ({ location }) => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code") ?? "";
    const state = params.get("state") ?? "";

    if (!code || !state) {
      throw redirect({ to: "/login", search: { error: "sso_failed" } });
    }

    try {
      const { data } = await axios.get(
        `${import.meta.env.VITE_BASE_URL}${authEndpoints.callbackSso}?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
      );
      applySessionResponseToStore(data);
      const returnPath = consumeReturnPath();
      throw redirect(returnPath ? toNavigateTarget(returnPath) : { to: "/" });
    } catch (error) {
      if (error instanceof Response || (error as { _isRedirect?: boolean })?._isRedirect) {
        console.error(error);
      }
      throw redirect({ to: "/login", search: { error: "sso_failed" } });
    }
  },
  component: SsoCallbackComponent,
});

function SsoCallbackComponent() {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1rem",
        paddingTop: "4rem",
      }}
    >
      <Loader size="md" />
      <Text c="dimmed">Completing sign-in, please wait…</Text>
    </Box>
  );
}
